import { MessagePrimitive, useAuiState, type TextMessagePartProps } from "../aui";

/** The line's text alone: assistant-ui's own Text wraps it in a <p>, and the line is one. */
const EventText = ({ text }: TextMessagePartProps) => <>{text}</>;

/** A line the server wrote into the thread (an event the assistant waited for happened): muted and
 * centred, never anyone's bubble. A boundary, where the user cleared the conversation, is a
 * divider: the assistant reads nothing above it. Each wait posts one, so every line shows, the
 * same text too. */
export function EventMessage() {
  const boundary = useAuiState((state) => !!state.message.metadata.custom?.boundary);
  if (boundary) {
    return (
      <MessagePrimitive.Root
        role="separator"
        aria-label="Context cleared"
        className="flex items-center gap-3 text-xs text-muted-foreground"
      >
        <span className="h-px flex-1 bg-border" aria-hidden />
        Context cleared
        <span className="h-px flex-1 bg-border" aria-hidden />
      </MessagePrimitive.Root>
    );
  }
  return (
    <MessagePrimitive.Root className="flex justify-center">
      <p className="text-center text-xs text-muted-foreground">
        <MessagePrimitive.Parts components={{ Text: EventText }} />
      </p>
    </MessagePrimitive.Root>
  );
}
